import type { Presupuesto } from '../../../api/ops/reservasGestion';

/**
 * Cómo se puede cobrar una reserva nueva desde el panel (8.2), según el presupuesto (`quoteReservation`):
 * - Sin enlace de pago (`link_required = false`, lo dice la API, G847): nada que elegir.
 * - Con garantía (G469) o con señal o prepago **y además** tarjeta de garantía (G793): solo «Enviar enlace de pago»; el
 *   enlace cobra la señal y guarda la tarjeta a la vez. «Ya lo ha pagado aquí» no se ofrece y se dice por qué.
 * - Si no, enlace o «Ya lo ha pagado aquí» con Efectivo o Datáfono (G461).
 */
export type FormaCobro = 'ninguno' | 'solo-enlace' | 'enlace-o-aqui';

export function formaDeCobro(p: Pick<Presupuesto, 'payment'> | null): FormaCobro {
    if (p === null || p.payment.link_required !== true) {
        return 'ninguno';
    }
    if (p.payment.kind === 'guarantee' || (p.payment.guarantee_amount?.amount ?? 0) > 0) {
        return 'solo-enlace';
    }
    return 'enlace-o-aqui';
}

/** Por qué no se ofrece «Ya lo ha pagado aquí». */
export function porQueSoloEnlace(p: Pick<Presupuesto, 'payment'>): string {
    return p.payment.kind === 'guarantee'
        ? 'Esta política pide la tarjeta de garantía: el cliente la deja con el enlace, así que no se puede marcar como pagada aquí.'
        : 'Esta política cobra una señal y además pide la tarjeta de garantía: el enlace hace las dos cosas a la vez, así que no se puede marcar como pagada aquí.';
}

/** Texto de un error de `createReservation` por su `code` (G856: ya no en `errors[0].code`). */
export const ERRORES_CREAR: Readonly<Record<string, string>> = {
    guarantee_requires_link: 'Con tarjeta de garantía, el cobro va siempre por enlace.',
    deposit_with_guarantee_requires_link: 'Con señal y tarjeta de garantía, el cobro va siempre por enlace.',
};
